import { createAction } from "redux-actions";
import { GET_QUOTAS, UPDATE_QUOTAS, UPDATE_QUOTAS_REDUCE } from "../constants";
import {  feathersFindDataAll } from "../services";
import { serverUpdateData } from "../services/crud";

export const getQuotas = createAction(GET_QUOTAS, (data) => feathersFindDataAll('quotas', data)())
export const updateQuotas = createAction(UPDATE_QUOTAS, (id, data) => serverUpdateData('quotas', id, data)())
export const updateQuotasReduce = createAction(UPDATE_QUOTAS_REDUCE, (data) => [data])